// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d4vDHiXBd1WM5qAti63W {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  user-select: none;
  cursor: pointer;
}
.d4vDHiXBd1WM5qAti63W > i {
  flex: 1.2em 0 0;
  height: 1.2em;
  border: 1px solid var(--dry-border-color);
  border-radius: 3px;
}
.d4vDHiXBd1WM5qAti63W > i > svg:first-child {
  fill: var(--dry-primary-text);
}
.d4vDHiXBd1WM5qAti63W[data-checked="true"] > i {
  border-color: var(--dry-primary);
  background-color: var(--dry-primary);
}
.d4vDHiXBd1WM5qAti63W[data-placement="right"] {
  flex-direction: row-reverse;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `d4vDHiXBd1WM5qAti63W`
};
export default ___CSS_LOADER_EXPORT___;
